export function getWeekDay(day: number) {
    switch (day) {
        case 0:
            return 'monday';
        case 1:
            return 'tuesday';
        case 2:
            return 'wednesday';
        case 3:
            return 'thursday';
        case 4:
            return 'friday';
        case 5:
            return 'saturday';
        case 6:
            return 'sunday';
        default:
            return '';
    }
}

export function translateWeekday(day: string) {
    switch (day) {
        case 'monday':
            return 'segunda-feira';
        case 'tuesday':
            return 'terça-feira';
        case 'wednesday':
            return 'quarta-feira';
        case 'thursday':
            return 'quinta-feira';
        case 'friday':
            return 'sexta-feira';
        case 'saturday':
            return 'sábado';
        case 'sunday':
            return 'domingo';
        default:
            return '';
    }
}

export const parseJwt = (token: string) => {
    var base64Url = token.split('.')[1]
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    var jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split('')
            .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            })
            .join('')
    )

    return JSON.parse(jsonPayload)
}

export function secondsToHour(seconds: number){
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}

export function capitalizeFirstLetter(input?: string): string {
    return input? input
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' '): ''
}

export const arrayMessagesConnectionTotvs = [
    'Não foi possível estabelecer uma conexão com a loja.',
    'Problemas na gravação dos itens.',
    'Mesa em digitação em outro terminal.',
    'Erro ao salvar pedido no sistema.',
    'NAO GERADO !',
]
export const arrayMessagesPaymentCard = [
    // Cielo errors
    { code: 'INVALID_CARD_NUMBER', message: 'Invalid card number', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique o número do cartão e tente novamente.' },
    { code: 'EXPIRED_CARD', message: 'Expired card', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique a data de validade do cartão e tente novamente.' },
    { code: 'INSUFFICIENT_FUNDS', message: 'Insufficient funds', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique o saldo disponível e tente novamente.' },
    { code: 'CARD_BLOCKED', message: 'Card blocked', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique se o cartão está bloqueado e tente novamente.' },
    { code: 'INVALID_SECURITY_CODE', message: 'Invalid security code', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique o código de segurança e tente novamente.' },
    { code: 'TRANSACTION_NOT_PERMITTED', message: 'Transaction not permitted', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique se a transação é permitida e tente novamente.' },
    { code: 'CARD_NOT_SUPPORTED', message: 'Card not supported', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique se o cartão é suportado e tente novamente.' },
    { code: 'TIMEOUT', message: 'Timeout', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, tente novamente.' },
    { code: 'PROCESSING_ERROR', message: 'Processing error', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, tente novamente.' },
    { code: 'FRAUD_SUSPECTED', message: 'Fraud suspected', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique os dados informados e tente novamente.' },

    // e.Rede errors
    { code: 'INVALID_CVV', message: 'Invalid CVV', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique o CVV informado e tente novamente.' },
    { code: 'CARD_EXPIRED', message: 'Card expired', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique a data de validade do cartão e tente novamente.' },
    { code: 'DO_NOT_HONOR', message: 'Do not honor', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique os dados informados e tente novamente.' },
    { code: 'LOST_CARD', message: 'Lost card', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique se o cartão está perdido e tente novamente.' },
    { code: 'STOLEN_CARD', message: 'Stolen card', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique se o cartão está roubado e tente novamente.' },
    { code: 'RESTRICTED_CARD', message: 'Restricted card', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique se o cartão está restrito e tente novamente.' },
    { code: 'AMOUNT_ERROR', message: 'Amount error', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique o valor informado e tente novamente.' },
    { code: 'INVALID_TRANSACTION', message: 'Invalid transaction', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, verifique os dados informados e tente novamente.' },
    { code: 'ISSUER_UNAVAILABLE', message: 'Issuer unavailable', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, tente novamente mais tarde.' },
    { code: 'SYSTEM_ERROR', message: 'System error', translated: 'Não foi possível completar o pagamento do seu pedido. Por favor, tente novamente.' },
]